import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import MainContent from './MainContent'
import { GeneralAppStorageContextProvider } from './app/GeneralAppStorageContext'
import LookupContextProvider from './app/LookupContext'
import { PermissionsProvider } from './app/PermissionsContext'
import { RoleIndicatorRefProvider } from './app/RoleIndicatorRefContext'
import Spinner from './app/Spinner'
import { PageTitleProvider } from './app/PageTitleContext'

export default function App() {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = t('app.title', 'Data Management Console')
  }, [t])

  return (
    <PermissionsProvider>
      <LookupContextProvider>
        <GeneralAppStorageContextProvider>
          <RoleIndicatorRefProvider>
            <Spinner />
            <PageTitleProvider>
              <MainContent />
            </PageTitleProvider>
          </RoleIndicatorRefProvider>
        </GeneralAppStorageContextProvider>
      </LookupContextProvider>
    </PermissionsProvider>
  )
}
